import axios from 'axios';

export function getKisaanBaseURL() {
  return process.env.APP_KISAN_URI;
}

const getProfileUrl = (userId: string, realmId: string) => {
  return `${getKisaanBaseURL()}/kisaan/user/${userId}/${realmId}`;
};

// updateUserLanguage.ts
export const updateUserLanguage = async (
  languageCode: string,
  userId: string,
  realmId: string,
  accessToken: string,
  setUserProfile: (profile: any) => void
) => {
  try {
    const payload = { languageCode };

    const response = await axios.patch(getProfileUrl(userId, realmId), payload, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    if (response?.data?.data) {
      const userDetail = {
        realm: response.data.data.realmData.Realm,
        user: response.data.data.userData.User,
        access_token: accessToken,
      };

      setUserProfile(userDetail);
    }

    return response?.data ?? undefined;
  } catch (error) {
    console.error('Update failed for language code!!!', error);
  }

  return undefined;
};
